import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiJava,
  DiMysql,
} from "react-icons/di";
import {
  SiRedis,
  SiPostgresql,
  SiDotnet,
  SiElasticsearch,
  SiGooglecloud,
  SiTensorflow,
  SiPytorch,
} from "react-icons/si";
import { TbBrandCSharp } from "react-icons/tb";
import { VscAzure } from "react-icons/vsc";
import { FaAws, FaGit, FaDocker } from "react-icons/fa";
function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <DiPython />
          <div style={{ fontSize: "18px" }}>Python</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <DiJavascript1 />
          <div style={{ fontSize: "18px" }}>JavaScript</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <TbBrandCSharp />
          <div style={{ fontSize: "18px" }}>C#</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <DiJava />
          <div style={{ fontSize: "18px" }}>Java</div>
        </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <DiReact />
          <div style={{ fontSize: "18px" }}>React</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <DiNodejs />
          <div style={{ fontSize: "18px" }}>Node.js</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <SiDotnet />
          <div style={{ fontSize: "18px" }}>.NET</div>
        </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <SiTensorflow />
          <div style={{ fontSize: "18px" }}>TensorFlow</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <SiPytorch />
          <div style={{ fontSize: "18px" }}>PyTorch</div>
        </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <DiMysql />
          <div style={{ fontSize: "18px" }}>MySQL</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <SiElasticsearch />
          <div style={{ fontSize: "18px" }}>Elasticsearch</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <DiMongodb />
          <div style={{ fontSize: "18px" }}>MongoDB</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <SiPostgresql />
          <div style={{ fontSize: "18px" }}>PostgreSQL</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <SiRedis />
          <div style={{ fontSize: "18px" }}>Redis</div>
        </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <VscAzure />
          <div style={{ fontSize: "18px" }}>Azure</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <FaAws />
          <div style={{ fontSize: "18px" }}>AWS</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <SiGooglecloud />
          <div style={{ fontSize: "18px" }}>Google Cloud</div>
        </div>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <FaGit />
          <div style={{ fontSize: "18px" }}>Git</div>
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <div style={{ textAlign: "center" }}>
          <FaDocker />
          <div style={{ fontSize: "18px" }}>Docker</div>
        </div>
      </Col>

    </Row>
  );
}

export default Techstack;
